import React from "react";
import { Route, Switch } from "react-router-dom";
import Leads from "./leads/leads";
import leadDetail from "./leads/leadDetail/leadDetail";
import Inquiries from "./inquiries/inquiries";
import Ticket from "./ticket/ticket";
import Slc from "./slc/slc";
import SalesJourney from "./journey/salesJourney";
import JourneyForm from "./journey/journeyForm/journeyForm";
import JourneyDetail from "./journey/journeyDetail/journeyDetail";
import VisitDetail from "./journey/journeyDetail/visitDetail";
import CrmReport from "./crm-report/CrmReport";
import ActivityTaskForm from "./journey/journeyDetail/activityTaskForm";

export default function CRMPage() {
  return (
    <Switch>
      <Route path="/crm/leads" component={Leads} />
      <Route path="/crm/lead-detail/:leadID" component={leadDetail} />
      <Route path="/crm/inquiry" component={Inquiries} />
      <Route path="/crm/ticket" component={Ticket} />
      <Route path="/crm/slc" component={Slc} />
      <Route path="/crm/sales-journey" component={SalesJourney} />
      <Route path="/crm/journey-form" component={JourneyForm} />
      <Route path="/crm/crm-reports" component={CrmReport} />
      <Route path="/crm/journey-detail/:journeyID" component={JourneyDetail} />
      <Route path="/crm/visit-detail/:visitID" component={VisitDetail} />
      <Route
        path="/crm/visit-activity-tasks/:journeyID/:visitActivityID"
        component={ActivityTaskForm}
      />
    </Switch>
  );
}
